import { combineReducers } from "redux";
import reCaptcha from "./reCaptcha";
import sendProspectToAPI from "./sendProspectToAPI";
import searchProspect from "./searchProspect";
import stakeholders from "./stakeholders";
import completedSteps from "./completedSteps";
import login from "./loginForm";
import otp from "./otp";
import serverValidation from "./serverValidation";
import accountNumbers from "./accountNumbers";
import appConfig from "./appConfig";
import uploadDocuments from "./uploadDocuments";
import retrieveApplicantInfo from "./retrieveApplicantInfo";
import sendAecbFtsEmail from "./sendAecbFtsEmail";
import signatoryInfo from "./getSignatoryInfo";
import agentFeatures from "./agentFeatures";
import sendAdhocEmail from "./sendAdhocEmail";

/**
 * Combined reducers for the application
 * With React Router v6, we no longer need to include router state in Redux
 */
const reducers = () =>
  combineReducers({
    appConfig,
    reCaptcha,
    sendProspectToAPI,
    otp,
    searchProspect,
    completedSteps,
    stakeholders,
    login,
    serverValidation,
    accountNumbers,
    retrieveApplicantInfo,
    uploadDocuments,
    sendAecbFtsEmail,
    signatoryInfo,
    agentFeatures,
    sendAdhocEmail
  });

export default reducers;
